import { toast } from "sonner";

import { OutgoingIntakesAPI } from "@/api/outgoingIntakesApi";
import type { OutgoingIntakeFile } from "@/api/types/outgoingIntake";

/** Open a client upload in a new tab: its signed URL, or the bytes as a blob. */
export const openIntakeFile = async (
  clientId: string,
  intakeId: string,
  file: OutgoingIntakeFile
): Promise<void> => {
  if (file.download_url) {
    window.open(file.download_url, "_blank", "noopener,noreferrer");
    return;
  }
  try {
    const res = await OutgoingIntakesAPI.getFile(
      clientId,
      intakeId,
      file.file_id
    );
    const bytes = Uint8Array.from(atob(res.data), (c) => c.charCodeAt(0));
    const url = URL.createObjectURL(
      new Blob([bytes], {
        type: file.content_type || "application/octet-stream"
      })
    );
    window.open(url, "_blank", "noopener,noreferrer");
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (e) {
    toast.error(e instanceof Error ? e.message : "Couldn't open the file");
  }
};
